import React from 'react'
import PlanEntryListLoading from './PlanEntryListLoading'
import PlanEntryListHeader from './PlanEntryListHeader'
import InfiniteScroll from 'react-infinite-scroll-component'
import HelpPopup from '../helpPopup/HelpPopup'
import PropTypes from 'prop-types'
import PlanEntriesListRows from './PlanEntriesListRows'

const PlanEntriesListContent = ({
  autopaginate,
  entries,
  isLoading,
  favoritable,
  featurable,
  headers,
  onReorder,
  orderBy,
  hasMore,
  onFetchMoreEntries,
  onPlanEntriesSorted,
  sortable,
  onDeleted,
  removable,
  locked,
  includeDates,
  initialLoad,
  entryLinkSuffix
}) => {
  const listHeaders = headers.map((header, idx) => (
    <span
      className={`PlanEntriesListContent__header PlanEntryListRow__${
        header.value
      }`}
      key={idx}
    >
      <PlanEntryListHeader
        {...header}
        orderBy={orderBy}
        onClick={order => {
          onReorder(order, header.value)
        }}
      />
    </span>
  ))

  let loadingRows
  if (isLoading) {
    loadingRows = new Array(20)
      .fill(null)
      .map((_, idx) => <PlanEntryListLoading key={idx} />)
  }

  let planEntryRows
  if (!initialLoad) {
    planEntryRows = (
      <PlanEntriesListRows
        locked={locked}
        sortable={sortable}
        favoritable={favoritable}
        featurable={featurable}
        entries={entries}
        onSortEnd={onPlanEntriesSorted}
        onDeleted={onDeleted}
        removable={removable}
        includeDates={includeDates}
        entryLinkSuffix={entryLinkSuffix}
      />
    )
  }

  let favoriteButtonHeaderSpace
  if (favoritable) {
    favoriteButtonHeaderSpace = (
      <span className='PlanEntryListRow__favoriteButton' />
    )
  }

  let seeMoreBtn
  if (!autopaginate && hasMore) {
    seeMoreBtn = (
      <a className='see-more' onClick={onFetchMoreEntries}>
        See More
      </a>
    )
  }

  return (
    <div className='PlanEntriesList'>
      <div className='PlanEntriesList__headers' key={0}>
        <span className='PlanEntryListRow__dragHandle' />
        {favoriteButtonHeaderSpace}
        <span className='PlanEntryListRow__completedIcon'>
          <HelpPopup
            trigger={
              <a
                href='#'
                className='hovertip'
                style={{ marginLeft: 0, paddingLeft: 2.5 }}
              >
                ?
              </a>
            }
            topOffset={-10}
            leftOffset={250}
            width={540}
          >
            The checkmark below indicates whether or not you have finished the
            class
          </HelpPopup>
        </span>

        <span className='PlanEntryListRow__image' />
        <React.Fragment>{listHeaders}</React.Fragment>
        <span className='PlanEntryListRow__options' />
      </div>
      <InfiniteScroll
        hasMore={autopaginate && hasMore}
        dataLength={entries.length}
        next={onFetchMoreEntries}
        style={{ overflow: 'visible' }}
      >
        {planEntryRows}
        {loadingRows}
      </InfiniteScroll>
      {seeMoreBtn}
    </div>
  )
}

PlanEntriesListContent.propTypes = {
  autopaginate: PropTypes.bool,
  entries: PropTypes.array,
  isLoading: PropTypes.bool,
  initialEntryLoad: PropTypes.bool,
  dateAddedField: PropTypes.string,
  editable: PropTypes.bool,
  headers: PropTypes.array,
  onReorder: PropTypes.func,
  onSorted: PropTypes.func,
  orderBy: PropTypes.string,
  hasMore: PropTypes.bool,
  onFetchMoreEntries: PropTypes.func,
  favoritable: PropTypes.bool,
  featurable: PropTypes.bool,
  onPlanEntriesSorted: PropTypes.func,
  sortable: PropTypes.bool,
  onDeleted: PropTypes.func,
  removable: PropTypes.bool,
  locked: PropTypes.bool,
  includeDates: PropTypes.bool,
  initialLoad: PropTypes.bool,
  entryLinkSuffix: PropTypes.string
}

export default PlanEntriesListContent
